import { useEffect, useState } from "react";
import { CustomDropdown } from "../../../componentes/dropdown/CustomDropdown";
import UsuarioService from "../../../services/resource/usuarioService";
import GrupoService from "../../../services/resource/grupoService";
import { STATUS_CONFIG } from "../../../utils/solicitacoes/statusConfig";
import { PROCESSO_REGISTRY, processoInfo } from "../../../utils/solicitacoes/processoRegistry";

const STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(([value, info]) => ({ value, label: info.label }));

const PROCESSO_OPTIONS = Object.entries(PROCESSO_REGISTRY).map(([value, info]) => ({ value, label: info.label }));

// Filial e Prioridade não entram aqui: não existem no SolicitacaoDTO genérico usado por
// Todas as Solicitações / Minhas Tarefas / Minhas Solicitações (só nos detalhes por processo).
const CAMPOS_PADRAO = ["tipoProcesso", "status", "solicitanteId", "responsavelId", "grupoId", "dataInicial", "dataFinal"];

export default function FiltroSolicitacao({ value, onChange, campos = CAMPOS_PADRAO }) {
    const [usuarios, setUsuarios] = useState([]);
    const [grupos, setGrupos] = useState([]);

    useEffect(() => {
        const usuarioService = new UsuarioService();
        const grupoService = new GrupoService();

        usuarioService.listarUsuarios().then(res => setUsuarios(res.data)).catch(() => setUsuarios([]));
        grupoService.listarGrupos().then(res => setGrupos(res.data)).catch(() => setGrupos([]));
    }, []);

    function set(campo, novoValor) {
        onChange({ ...value, [campo]: novoValor });
    }

    const mostrar = (campo) => campos.includes(campo);

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {mostrar("tipoProcesso") && (
                <Campo label="Processo">
                    <CustomDropdown
                        value={value.tipoProcesso ?? null}
                        onChange={e => set("tipoProcesso", e.value)}
                        options={PROCESSO_OPTIONS}
                        placeholder="Todos os processos"
                        showClear
                        filter
                    />
                </Campo>
            )}

            {mostrar("status") && (
                <Campo label="Situação">
                    <CustomDropdown
                        value={value.status ?? null}
                        onChange={e => set("status", e.value)}
                        options={STATUS_OPTIONS}
                        placeholder="Todas as situações"
                        showClear
                    />
                </Campo>
            )}

            {mostrar("solicitanteId") && (
                <Campo label="Solicitante">
                    <CustomDropdown
                        value={value.solicitanteId ?? null}
                        onChange={e => set("solicitanteId", e.value)}
                        options={usuarios}
                        optionValue="id"
                        optionLabel="nome"
                        placeholder="Todos os solicitantes"
                        showClear
                        filter
                    />
                </Campo>
            )}

            {mostrar("responsavelId") && (
                <Campo label="Responsável">
                    <CustomDropdown
                        value={value.responsavelId ?? null}
                        onChange={e => set("responsavelId", e.value)}
                        options={usuarios}
                        optionValue="id"
                        optionLabel="nome"
                        placeholder="Todos os responsáveis"
                        showClear
                        filter
                    />
                </Campo>
            )}

            {mostrar("numero") && (
                <Campo label="Número">
                    <input
                        type="text"
                        value={value.numero ?? ""}
                        onChange={e => set("numero", e.target.value)}
                        placeholder="Buscar por número"
                        className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                    />
                </Campo>
            )}

            {mostrar("etapaCodigo") && (
                <Campo label="Etapa">
                    <CustomDropdown
                        value={value.etapaCodigo ?? null}
                        onChange={e => set("etapaCodigo", e.value)}
                        options={processoInfo(value.tipoProcesso)?.etapas || []}
                        optionValue="codigo"
                        optionLabel="label"
                        placeholder={value.tipoProcesso ? "Todas as etapas" : "Escolha um processo primeiro"}
                        disabled={!value.tipoProcesso}
                        showClear
                    />
                </Campo>
            )}

            {mostrar("grupoId") && (
                <Campo label="Grupo">
                    <CustomDropdown
                        value={value.grupoId ?? null}
                        onChange={e => set("grupoId", e.value)}
                        options={grupos}
                        optionValue="id"
                        optionLabel="nome"
                        placeholder="Todos os grupos"
                        showClear
                        filter
                    />
                </Campo>
            )}

            {mostrar("dataInicial") && (
                <Campo label="Data inicial">
                    <input
                        type="date"
                        value={value.dataInicial ?? ""}
                        onChange={e => set("dataInicial", e.target.value)}
                        className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                    />
                </Campo>
            )}

            {mostrar("dataFinal") && (
                <Campo label="Data final">
                    <input
                        type="date"
                        value={value.dataFinal ?? ""}
                        onChange={e => set("dataFinal", e.target.value)}
                        className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                    />
                </Campo>
            )}
        </div>
    );
}

function Campo({ label, children }) {
    return (
        <div className="flex flex-col gap-1.5">
            <label className="text-sm font-medium text-foreground/80">{label}</label>
            {children}
        </div>
    );
}
